import { combineReducers } from "@reduxjs/toolkit"
import signupReducer from "./Auth/signupReducer"
import verifyOtpReducer from "./Auth/verifyOtpReducer"
import resendOtpReducer from "./Auth/resendOtpReducer"
import selectRoleReducer from "./Auth/selectRoleReducer"
import loginReducer from "./Auth/loginReducer"
import logoutReducer from "./Auth/logoutReducer"
import getMeReducer from "./Auth/getMeReducer"
import onboardingReducer from "./Onboarding/onboardingReducer"
import discoveryReducer from "./Discovery/discoveryReducer"
import campaignReducer from "./Campaign/campaignReducer"
import notificationsReducer from "./Notification/notificationsReducer"
import chatReducer from "./Chat/getAllChatReducer"
import milestoneReducer from "./Milestone/milestoneReducer"
import settingsReducer from "./Settings/settingsReducer"
import walletReducer from "./Wallet/walletReducer"
import agencyReducer from "./Agency/agencyReducer"
import ratingReducer from "./Rating/ratingReducer"
import deliverableReducer from "./Deliverable/deliverableReducer"
import affiliateReducer from "./Affiliate/affiliateReducer"
import ugcReducer from "./Ugc/ugcReducer"
import * as types from "../Action/actionTypes"

const appReducer = combineReducers({
  signup: signupReducer,
  verifyOtp: verifyOtpReducer,
  resendOtp: resendOtpReducer,
  selectRole: selectRoleReducer,
  login: loginReducer,
  logout: logoutReducer,
  getMe: getMeReducer,
  onboarding: onboardingReducer,
  discovery: discoveryReducer,
  campaign: campaignReducer,
  notifications: notificationsReducer,
  chat: chatReducer,
  milestone: milestoneReducer,
  settings: settingsReducer,
  wallet: walletReducer,
  agency: agencyReducer,
  rating:       ratingReducer,
  deliverable:  deliverableReducer,
  affiliate:    affiliateReducer,
  ugc:          ugcReducer,
})

export const rootReducer = (state, action) => {
  if (action.type === types.LOGOUT) {
    try {
      localStorage.clear()
      sessionStorage.clear()
    } catch (e) {
      console.error("Error clearing storage on logout", e)
    }
    // Setting state to undefined resets all Redux slice reducers back to their initial state
    state = undefined
  }
  return appReducer(state, action)
}
